import React from 'react';
import { Modal } from 'react-bootstrap';

const UpdateSkinServiceDetails = ({ editSkinServiceModal, setEditSkinServiceModal, skinServiceDetailsFormData, handleSubmitUpdateSkinServiceDetails, handleChangeSkinServiceFormData }) => {
    return (
        <>
            <Modal
                centered
                show={editSkinServiceModal}
                onHide={() => setEditSkinServiceModal(false)}
                size={"lg"}
            >
                <div className="modal-header">
                    <h3 className="modal-title" id="exampleModalLabel">Update Skin Service Details</h3>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setEditSkinServiceModal(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmitUpdateSkinServiceDetails}>
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="serviceDetailName" className="col-form-label">
                                        Name:
                                    </label>
                                    <input
                                        name="serviceDetailName"
                                        value={skinServiceDetailsFormData?.serviceDetailName}
                                        onChange={(e) => handleChangeSkinServiceFormData(e)}
                                        type="text"
                                        className="form-control"
                                        placeholder="Skin Service Name"
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="pt_price" className="col-form-label">
                                        Patient Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="pt_price"
                                        value={skinServiceDetailsFormData.pt_price}
                                        onChange={(e) => handleChangeSkinServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Patient Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="tax" className="col-form-label">
                                        Tax:
                                    </label>
                                    <input
                                        type="text"
                                        name="tax"
                                        value={skinServiceDetailsFormData.tax}
                                        onChange={(e) => handleChangeSkinServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Tax"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="client_price" className="col-form-label">
                                        Client Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="client_price"
                                        value={skinServiceDetailsFormData.client_price}
                                        onChange={(e) => handleChangeSkinServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Client Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="status" className="col-form-label">
                                        Status:
                                    </label>
                                    <div className='d-flex align-items-center gap-4'>
                                        {["Active", "Inactive", "Deleted"].map((status) => (
                                            <div className="form-check me-3" key={status}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="status"
                                                    id={status.toLowerCase()}
                                                    value={status}
                                                    checked={skinServiceDetailsFormData.status === status}
                                                    onChange={(e) => handleChangeSkinServiceFormData(e)}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={status.toLowerCase()}
                                                >
                                                    {status}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setEditSkinServiceModal(false)}
                            >
                                Close
                            </button>
                            <button type="submit" className="btn btn-success">Update</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
};

export default UpdateSkinServiceDetails;